import {
    WarningGuestsDisabledGroupWithGuests,
    WarningGuestsDisabledGroupWithGuestsMultiple,
} from './getGuestsDisabledMessageViewState.locstring.json';
import loc from 'owa-localize';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getGenericMessageElementAndParts } from './getGenericMessageParts';
import { MailTipsCategory } from '../datapoints';

/**
 * @param recipients is the list of recipients
 * @param onRemoveRecipientsClick callback when remove button is pressed from an infoBar
 * @returns InfoBarMessageViewState for recipients whose are guests.
 * @returns null if no recipient are guests.
 */
export default (
    recipients: EmailAddressWrapper[],
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!recipients.length) {
        return null;
    }
    const [messageElement, messageParts, messageString] = getGenericMessageElementAndParts(
        recipients,
        loc(WarningGuestsDisabledGroupWithGuests),
        loc(WarningGuestsDisabledGroupWithGuestsMultiple),
        onRemoveRecipientsClick,
        MailTipsCategory.GuestsDisabledGroupsWithGuests
    );
    return {
        key: 'GuestsDisabledGroupWithGuests',
        message: messageString,
        messageElement,
        messageParts,
        rank: InfoBarMessageRank.Info,
        source: InfoBarMessageSource.Compose,
    };
};
